import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { DevToolService } from '../dev-tool.service';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { WINDOW } from '@core/window.token';

type PortalTypes = 'student' | 'institution' | 'admin';

interface DevUser {
  id: string;
  name: string;
  portal?: PortalTypes;
}

const PORTAL_PATHS = {
  student: '/student',
  institution: '/',
  admin: '/',
} as const;

@Component({
  selector: 'app-dev-mode-panel',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatSelectModule,
    MatButtonModule,
  ],
  templateUrl: './dev-tool-panel.component.html',
  styleUrls: ['./dev-tool-panel.component.scss'],
})
export class DevModePanelComponent {
  private readonly devMode = inject(DevToolService);
  private readonly fb = inject(FormBuilder);
  private readonly window = inject(WINDOW);

  devModeForm: FormGroup;
  users: DevUser[] = [
    // Students
    { id: 'student-1', name: '(S) Lauren Lee, Riverside', portal: 'student' },
    { id: 'student-2', name: '(S) Robert Rivera, Riverside', portal: 'student' },
    { id: 'student-3', name: '(S) Samantha Martin, Northern', portal: 'student' },
    { id: 'student-4', name: '(S) Liam Cruz, Northern', portal: 'student' },
    { id: 'student-5', name: '(S) Evelyn Wilson, Metropolitan', portal: 'student' },
    { id: 'student-6', name: '(S) Oliver Ramirez, Metropolitan', portal: 'student' },
    { id: 'student-half', name: '(S) Demi Partial, Riverside ⚠️', portal: 'student' },

    // Institutions
    { id: 'institution-admin', name: '(I) Melissa Lewis, Riverside', portal: 'institution' },
    { id: 'institution-enrollment-manager', name: '(I) Isabella Fernandez, Riverside', portal: 'institution' },
    { id: 'institution-csr', name: '(I) Benjamin Cooper, Riverside', portal: 'institution' },
    { id: 'consortium-admin', name: '(I) Carl Consortium-Admin, Riverside', portal: 'institution' },

    // Admins
    { id: 'alliant-csr', name: 'Alliant CSR', portal: 'admin' },
    { id: 'alliant-account-manager', name: 'Alliant Account Manager', portal: 'admin' },
    { id: 'alliant-sysadmin', name: 'Alliant SysAdmin', portal: 'admin' },
  ];

  constructor() {
    this.devModeForm = this.fb.group({
      userId: [this.devMode.getUserId() || ''],
    });
  }

  onSubmit() {
    const userId = this.devModeForm.value.userId;
    const portal = this.getPortalToLoad(userId);
    this.devMode.setUserId(userId);
    this.window.location.replace(portal);
  }

  onReset(): void {
    this.devMode.clear();
    this.window.location.reload();
  }

  private getPortalToLoad(userId: string) {
    const user = this.users.find((u) => u.id === userId);

    return user?.portal ? PORTAL_PATHS[user.portal] : '/';
  }
}
